// extracted by mini-css-extract-plugin
export default {"root":"logo_root__8yOO4","logo-poradny":"logo_logo-poradny__yAZPr","logo-holky":"logo_logo-holky__MC2Li"};